// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1XENl","col":"CardReaderDesc_col__17j2q","label":"CardReaderDesc_label__2N9dL"};